import _ from 'underscore';

import { logError } from '../logger';
import { getBaseMicrodata } from './helpers';

const getAddress = (institute) => {
	const jsonData = {
		'@type': 'PostalAddress',
		addressCountry: 'Россия',
		streetAddress: institute.address
	};

	if (institute.city) {
		jsonData.addressLocality = institute.city.title;
	}

	if (institute.federalSubject) {
		jsonData.addressRegion = institute.federalSubject.title;
	}

	return jsonData;
};

export const getGeoCoordinates = (institute) => {
	let jsonData = {
		'@type': 'GeoCoordinates',
		address: getAddress(institute)
	};

	if (institute.location) {
		jsonData = _(jsonData).extend({
			latitude: institute.location.coordinates[1],
			longitude: institute.location.coordinates[0]
		});
	}

	return jsonData;
};

export const getInstituteMicrodata = (institute) => {
	let jsonData = {};

	try {
		jsonData = getBaseMicrodata(institute, {
			type: 'Place',
			entityType: 'institutes'
		});

		jsonData.geo = getGeoCoordinates(institute);

		if (institute.contacts) {
			jsonData.telephone = _(institute.contacts.phones)
				.pluck('value')
				.join(', ');
		}
	} catch (err) {
		logError(`institute microdata error: ${err.stack || err}`);
	}

	return JSON.stringify(jsonData);
};
